// @flow
import React, { type Node } from 'react';
import './EstimateSection.scss';

type Props = {
  children: Node,
  name: string,
};

const EstimateSection = ({ children, name }: Props) => (
  <section className="EstimateSection">
    <h4>{name}</h4>
    <div className="section-contents">{children}</div>
  </section>
);

export default EstimateSection;



// WEBPACK FOOTER //
// ./src/components/estimate/EstimateSection/EstimateSection.js